import s3 from 'lib/s3/s3Helper';
import { getExplicitUploadHeaders } from 'lib/s3/uploadHeaders';
import sanitize from 'sanitize-filename';
import { UploadService } from './UploadService';
import { WithErrorService } from '../../front/ErrorService/ErrorService';
import { WithServices } from '../../../platform/ts/services';

export function createUploadService(
  config: WithServices<[WithErrorService]>
): UploadService {
  const { errorService } = config.services;
  const interceptor = errorService.withCategory('UploadService');

  const sanitizeFilename = (filename: string) => {
    return sanitize(filename.trim().replace(/\s+/g, ''));
  };
  const getS3UploadUrlForFile = async (file: File, secure: boolean) => {
    if (!file) return;

    const fileName = sanitizeFilename(file.name);
    let extension = fileName.split('.').pop()?.toLowerCase();
    extension = extension === 'jpeg' ? 'jpg' : extension;

    const result = await s3.getUrl({
      content_type: file.type ? file.type : 'application/*',
      extension: extension,
      name: fileName,
      secure: secure,
      size: file.size
    });

    if (result && result.data) {
      return result.data;
    } else {
      throw new Error('URL FAILED TO RETURN.');
    }
  };

  return {
    uploadMedia: interceptor.wrap(async options => {
      const result = await getS3UploadUrlForFile(options.media, options.secure);
      const { url, fileId, accessUrl } = result;
      //   const file_to_submit = {
      //     raw: options.media,
      //     file_id: fileId,
      //     url,
      //     name: sanitizeFilename(options.media.name)
      //   };
      return new Promise((resolve, reject) => {
        s3.uploadFile({
          uploadTo: url,
          accessUrl: accessUrl,
          headers: getExplicitUploadHeaders(result),
          file: options.media,
          onComplete: () => resolve({ accessUrl, fileId }),
          onError: error => reject(error),
          onProgress: options.onProgress,
          secure: options.secure
        });
      });
    })
  };
}
